import React from 'react'
import { useFormContext } from 'react-hook-form'

function WithoutLoginConditon({ smartShipCheck, props }) {
    const methods = useFormContext();

    const customer_check = props?.customerCheck;


    return (
        <div className="checkbox">

            <div className="mb-0 form-check field-class">
                <div className="form-group">
                    <input type="checkbox" ref={methods?.register({ required: false })} className="form-check-input" id="Terms-Condition" name="termscondition" />
                    <label className="form-check-label" htmlFor="Terms-Condition">
                        I would like to receive communications by mobile (text message)
                    </label>
                </div>

                {/* {errors.termscondition && <span className="error">This field  is required</span>}*/}

                <div className="form-group">
                    <input
                        type="checkbox"
                        ref={methods?.register({ required: false })}
                        className="form-check-input"
                        id="Terms-Condition2"
                        name="termscondition1"
                    />
                    <label
                        className="form-check-label"
                        htmlFor="Terms-Condition2"
                    >
                        Email me with news and offers
                    </label>
                </div>
                {/*<div className="form-group">
                    <input type="checkbox" ref={methods?.register({ required: false })} className="form-check-input" id="Terms-Condition3" name="termscondition2" />
                    <label className="form-check-label" htmlFor="Terms-Condition3">
                        I would like to receive the SNiP Newsletter by email
                    </label>
                </div>*/}
                <div className="form-group">
                    <div className="policy">
                        <div className='wrap-checkout'>
                            <input type="checkbox" className="form-check-input"
                                id="termsconditions" name="termscondition3"
                                ref={methods?.register({
                                    required: "Please read and accept the conditions"
                                })} />
                            <label htmlFor='termsconditions' className="form-check-label"> I have read and agree to the
                                <a className="privacy_style" target='_blank' href="https://admin.snipnutrition.com/media/documents/snip_nutrigenomics_return_refund_policy.pdf"> Return Policy</a>,
                                <a className="privacy_style" target='_blank' href='https://admin.snipnutrition.com/media/documents/Website%20privacy%20policy.pdf'> Privacy Policy</a>,
                                {customer_check !== 1 &&
                                    <a className="privacy_style" target='_blank'
                                        href='https://admin.snipnutrition.com/media/documents/SNiP_Permissible_Marketing.pdf'>
                                        Permissible Marketing
                                    </a>}
                                {/* <a className="privacy_style" target='_blank'
                                    href='https://admin.snipnutrition.com/media/documents/SNiP_Permissible_Marketing.pdf'> Permissible Marketing</a> */}
                                <span> and</span>

                                <a className="privacy_style" target='_blank'
                                    href='https://admin.snipnutrition.com/media/documents/snip_nutrigenomics_terms_and_conditions_clean_copy_v5.5.1.24.pdf'> Terms & Conditions </a>
                            </label>
                        </div>{methods?.errors.termscondition3 && (<div style={{ color: "red" }}>{methods?.errors.termscondition3?.message} </div>)}
                    </div>

                </div>


            </div>
        </div>
    )
}

export default WithoutLoginConditon;